import { BigNumberish } from 'ethers';
import { parseUnits } from 'ethers/lib/utils';
import { config } from '../../config/config';
import { toBigNumber } from '../../web3/utils';

const calculatePriceRange = (
    limitPrice: string,
    slippage: number,
    decimals: BigNumberish = config.orderBookDecimal
) => {
    const minPrice = toBigNumber(limitPrice, decimals)
        .mul(parseUnits((100 - slippage).toString(), decimals))
        .div(parseUnits('100', decimals))
        .toString();

    const maxPrice = toBigNumber(limitPrice, decimals)
        .mul(parseUnits((100 + slippage).toString(), decimals))
        .div(parseUnits('100', decimals))
        .toString();

    return [minPrice, maxPrice];
};

export default calculatePriceRange;
